import { render, staticRenderFns } from "./addInstock.vue?vue&type=template&id=b7110d98&scoped=true&"
import script from "./addInstock.vue?vue&type=script&lang=js&"
export * from "./addInstock.vue?vue&type=script&lang=js&"
import style0 from "./addInstock.vue?vue&type=style&index=0&id=b7110d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7110d98",
  null
  
)

export default component.exports